/* Covva — Carrousel horizontal pour la section Features.
   Bind sur tout .cvf-carousel : flèches prev/next + état disabled selon position scroll.
   Idempotent (data-cvf-init). */
(function () {
  function init() {
    document.querySelectorAll('.cvf-carousel').forEach(function (carousel) {
      if (carousel.dataset.cvfInit === '1') return;
      carousel.dataset.cvfInit = '1';

      var track = carousel.querySelector('.cvf-track');
      var prev = carousel.querySelector('.cvf-arrow--prev');
      var next = carousel.querySelector('.cvf-arrow--next');
      if (!track) return;

      function step() {
        var card = track.querySelector('.cvf-card');
        if (!card) return track.clientWidth * 0.9;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 1;
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft >= max;
        if (prev) prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        if (next) next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
